"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePromoBannerConfig = void 0;
var react_1 = require("react");
var next_intl_1 = require("next-intl");
var keys_1 = require("../../keys");
var useQuery_1 = require("../../useQuery");
var useConfig_1 = require("../../useConfig");
var config_1 = require("../config");
var parsePromoBannerConfig_1 = require("./parsePromoBannerConfig");
var usePromoBannerConfig = function (key, category) {
    if (category === void 0) { category = config_1.TEXT_CATEGORIES.PROMO_BANNERS; }
    var lang = (0, next_intl_1.useLocale)().toLowerCase();
    var config = (0, useConfig_1.useConfig)();
    var promoBannersFromAdmin = Boolean(config === null || config === void 0 ? void 0 : config.promoBannersFromAdmin);
    var _a = (0, useQuery_1.useQuery)({
        path: "".concat(keys_1.TEXTS, "?category=").concat(category),
        payload: {
            category: category,
            lang: lang,
        },
        canRender: promoBannersFromAdmin,
        onErrorRetry: function () { return false; },
    }), data = _a.data, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () {
        var _a, _b;
        if (!promoBannersFromAdmin)
            return null;
        var placeholder = config === null || config === void 0 ? void 0 : config.gameCardPlaceholder;
        if (isLoading) {
            return placeholder
                ? {
                    backgroundImage: placeholder,
                    backgroundImageMobile: placeholder,
                }
                : null;
        }
        return (0, parsePromoBannerConfig_1.parsePromoBannerConfig)((_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b[key]);
    }, [data, key, promoBannersFromAdmin, isLoading, config === null || config === void 0 ? void 0 : config.gameCardPlaceholder]);
};
exports.usePromoBannerConfig = usePromoBannerConfig;
